import linux from "../assets/images/osIcons/linux.png";
import linuxGolden from "../assets/images/osIcons/linux-golden.png";
import apple from "../assets/images/osIcons/apple.png";
import appleGolden from "../assets/images/osIcons/apple-golden.png";
import windows from "../assets/images/osIcons/windows.png";
import windowsGolden from "../assets/images/osIcons/windows-golden.png";

export const ICON_MAP = {
  linux: "linux",
  macos: "apple",
  windows: "windows"
};

export const ICON_IMAGE_MAP = {
  linux: linux,
  linuxGolden: linuxGolden,
  macos: apple,
  macosGolden: appleGolden,
  windows: windows,
  windowsGolden: windowsGolden
};
